// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// import { getAnalytics } from "firebase/analytics";
import { getFirestore, collection, doc, addDoc, setDoc } from "firebase/firestore";
// --- Anonymous Auth (easy to comment out) ---
import { getAuth, signInAnonymously, onAuthStateChanged } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAIOaAt7N-I2vQgJnSFC6FiP3EsFW9TJxc",
    authDomain: "boun-pt.firebaseapp.com",
    databaseURL: "https://boun-pt-default-rtdb.firebaseio.com",
    projectId: "boun-pt",
    storageBucket: "boun-pt.firebasestorage.app",
    messagingSenderId: "606398973503",
    appId: "1:606398973503:web:d82cc2c3cff4fe86a11a8a",
    measurementId: "G-8SKCZJV6EY"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
// const analytics = getAnalytics(app);
const db = getFirestore(app);

// --- Anonymous Auth (comment out if not working) ---
let userId = null;
const auth = getAuth(app);
signInAnonymously(auth)
    .then(() => {
        onAuthStateChanged(auth, (user) => {
            if (user) {
                userId = user.uid;
                // console.log('Signed in anonymously as:', userId);
            }
        });
    })
    .catch((error) => {
        console.error('Anonymous sign-in error:', error);
    });


function getUserId() {
    return userId;
}

async function addUserFromContactForm(name, email, phone, message) {
    const docRef = doc(db, "users", getUserId());
    await setDoc(docRef, {
        name: name,
        email: email,
        phone: phone,
        message: message,
        timestamp: new Date(), // Optional: add a timestamp
        isPaying: false
    });
}

async function sendEmailToSelf(name, email, phone, message) {
    try {
        const docRef = await addDoc(collection(db, "mail"), {
            to: ['bhp.chicago@gmail.com'],
            message: {
                subject: `${name} is interested in a consultation!`,
                html: `<p><strong>Name:</strong> ${name}</p>
                    <p><strong>Email:</strong> ${email}</p>
                    <p><strong>Phone:</strong> ${phone}</p>
                    <p><strong>Message:</strong> ${message}</p>`
            }
        });
        console.log("Document written with ID: ", docRef.id);
    } catch (e) {
        console.error("Error adding document: ", e);
    }
}

async function addPrompt(text) {
    try {
        const docRef = await addDoc(collection(db, "generate"), {
            prompt: text,
            userId: getUserId()
        });
        console.log("Document written with ID: ", docRef.id);
    } catch (e) {
        console.error("Error adding document: ", e);
    }
}

export { addPrompt, db, getUserId, addUserFromContactForm, sendEmailToSelf };